/* global _ */
import {name, mixins, props, data, defaultFormFields, validationsRules, EventBus} from './config'

export default {
  name,
  props,
  mixins,
  events: 'user.registration',
  data() {
    return {
      ...data,
      errorMessage: this.error,
      fields: {
        email: this.email
      }
    }
  },
  created() {
    this.setupForm(validationsRules, defaultFormFields)
    this.termsUrl = this.withTerms && (this.terms || '/terms-of-use')
    EventBus.$on('user.registration.error', (e, fields) => {
      if (this.showLoginProposalWhenEmailExists) {
        if (_.get(e, 'all.email')) {
          this.showLoginProposal = true
        }
      }
    })

  },
  watch: {
    'fields.first_name'(val) {
      if (this.withRacerName && !_.isEmpty(val)) {
        this.generateRacerName()
      }
    },
    'fields.last_name'(val) {
      if (this.withRacerName && !_.isEmpty(val)) {
        this.generateRacerName()
      }
    },
    'fields.country'() {
      this.fields.state = ''
    },
    async triggerSubmit(event) {
      if (event) {
        await this.initRegistration(event)
      }
    }
  },

  computed: {
    maxDateTime() {
      return this.getNow().toISODate()
    },
    showForm() {
      return this.showSuccessPopup || !this.isRegistered
    },
    showConfirmation() {
      return !this.noSuccessScreen && this.isRegistered
    },
    showRacerInput() {
      return this.withRacerName
    },
    showErrorMessage() {
      return !_.isEmpty(this.errorMessage)
    }
  },

  methods: {
    getComponentExtraClasses() {
      return [{
        processed: this.isRegistered,
      }]
    },
    async initRegistration(event) {
      this.resetFieldsValidation()
      this.fixValidateInputs()
      this.$v.$touch()
      this.formSubmitting = true
      const fields = _.clone(this.fields)
      const publicFields =_.omit(fields, ['password', 'password_confirmation'])
      this.pass = fields.password
      this.emit('before', publicFields)
      this.$emit('before', publicFields)
      if (!this.isAnyInvalid) {
        this.$emit('valid', fields)
        this.emit('valid', fields)
        if (this.disableActions) {
          return
        }
        try {
          this.emit('init', publicFields)
          this.$emit('init', publicFields)
          const [data] = await this.promise('user.registration', fields)
          Vue.set(this, 'registered', publicFields)
          this.emit('success', data, publicFields, this.pass)
          this.$emit('success', data, publicFields, this.pass)
          this.isRegistered = true
          this.resetForm()
        } catch (e) {
          this.showFormError(e, {'scrollTo': '.re-registration-box'})
          this.emit('error', e, publicFields)
          this.$emit('error', e, publicFields)
        } finally {
          this.emit('end', publicFields)
          this.$emit('end', publicFields)
        }
      } else {
        this.emit('invalid', publicFields)
        this.$emit('invalid', publicFields)
        this.scrollToFirstErrorElement()
      }
    },
    fixValidateInputs() {
      if (!this.withEmailConfirmation) {
        this.fields.email_confirmation = this.fields.email
      }
      if (!this.withPhoneConfirmation) {
        this.fields.phone_confirmation = this.fields.phone
      }
    },
    async resendConfirmation() {
      const payload = _.pick(this.registered, ['email'])
      this.$emit('resend', payload)
      EventBus.$emit('user.registration.resend-confirmation', payload)
      try {
        this.isResendingConfirmation = true
        const [data] = await this.promise('user.registration.resend-confirmation', payload)
      } catch (e) {
        //
      } finally {
        this.isResendingConfirmation = false
      }
    },
    generateRacerName() {
      if (!this.racerNameTouched) {
        this.fields.racername = [this.fields.first_name, this.fields.last_name].join(' ').trim()
      }
    },
  }
}
